import { useState } from 'react';
import { PremiumPaywallSignModes } from '../../../../../global/paywall/paywallInterfaces';
import { PremiumCalcalistPaywallDesktopSignup } from './premiumCalcalistPaywallDesktopSignUp';
import { PremiumCalcalistPaywallDesktopSignin } from './premiumCalcalistPaywallDesktopSignin';
import { LegalLink } from "../mobile/premiumCalcalistPaywallMobile"
 
 


interface PremiumCalcalistPaywallDesktopProps {
  setIsRedirecting: (isRedirect: boolean) => void;
  legalLinks: {terms: LegalLink; privacy: LegalLink};
}

export const PremiumCalcalistPaywallDesktop = (props:PremiumCalcalistPaywallDesktopProps) => {
  const [mode, setMode] = useState<PremiumPaywallSignModes>('signIn');
  const [emailOrPhone, setEmailOrPhone] = useState<string>('');
  const [agreesTerms, setAgreeTerms] = useState(false);
  const [password, setPassword] = useState('');
  const { setIsRedirecting,legalLinks } = props;
  
  const getFormByMode = () => {
    if (mode === 'signUp') {
      return (
        <PremiumCalcalistPaywallDesktopSignup
          email={emailOrPhone}
          password={password}
          agreesTerms={agreesTerms}
          setEmail={setEmailOrPhone}
          setPassword={setPassword}
          setAgreesTerms={setAgreeTerms}
          setMode={setMode}
          setIsRedirecting={setIsRedirecting}
          legalLinks={legalLinks}
        />
      );
    }
    return (
      <PremiumCalcalistPaywallDesktopSignin
        emailOrPhone={emailOrPhone}
        password={password}
        agreesTerms={agreesTerms}
        setEmailOrPhone={setEmailOrPhone}
        setPassword={setPassword}
        setAgreesTerms={setAgreeTerms}
        setMode={setMode}
        setIsRedirecting={setIsRedirecting}
      />);
  };

  return <div className="premium-calcalist-paywall-desktop">{getFormByMode()}</div>;
};
